/* eslint-disable react/forbid-prop-types */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';

export const ModsType = PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
]));

export const MixType = PropTypes.shape({
    block: PropTypes.string,
    elem: PropTypes.string,
    mods: ModsType
});

MixType.mix = MixType;

export const ChildrenType = PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
]);

export const RefType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
]);

export const MetaTitleType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);

export const HistoryType = PropTypes.shape({
    location: PropTypes.object,
    push: PropTypes.func
});

export const LocationType = PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
});

export const MatchType = PropTypes.shape({
    path: PropTypes.string
});
